import {gql} from 'apollo-angular';

export const GET_ROOKIE_TIME_SLOTS = gql`
  query GetRookieTimeSlots($districtId: Int!) {
    rookieTimeSlots(districtId: $districtId) {
      id
      name
      openAt
      closeAt
      workFrom
      workTo
      state
      schools {
        id
        schoolName
        timeSlot {
          id
        }
      }
    }
  }
`;
